var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"payment-info"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.$t('paymentProcessing'))+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }